var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-area-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "employments" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "9" } },
                [
                  _c("h1", [_vm._v("Zusagen")]),
                  _vm._v(" "),
                  _c("EmploymentsList", { attrs: { type: "customer" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }